import React from "react";

import style from "./Line.module.css";

function LineComponent({ color }) {
  return <div className={`${style.line}`} style={{ borderColor: color }} />;
}
export default LineComponent;
